module.exports = __webpack_public_path__ + "static/img/table_nykart.d465088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table_nykart.png
// module id = ZHIQ
// module chunks = 0